/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTDrawer } from './drawer';
export type { KTDrawerConfigInterface, KTDrawerInterface } from './types';
